<template>
  <div class="c-anti-fraud-alert">

    <p class="title">{{ antiFraudTitle }}</p>
    <paragraph :wording="antiFraudWording" />
    <div class="btn-wrap">
      <pr-button @click="closeDialog">確定</pr-button>
    </div>

  </div>
</template>
<script>
import {
  defineComponent,
  //  getCurrentInstance
} from 'vue';

import {
  antiFraudTitle,
  antiFraudWording,
} from '@/config/wording';
import PrButton from '@/components/Global/PrButton.vue';

export default defineComponent({
  name: 'AntiFraudAlert',
  components: {
    PrButton,
  },
  setup(props, { emit }) {
    const closeDialog = () => {
      emit('closeDialog', 'antiFraudAlert');
    };

    return {
      closeDialog,
      antiFraudTitle,
      antiFraudWording,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-anti-fraud-alert {
  @include padding(50px);
  @include flex(center, center, column);

  .title {
    @include font-style($c-main, 32, 500, 1.5px, normal);
    margin-bottom: 30px;
  }

  .btn-wrap {
    margin-top: 50px;
    @include flex();
  }
}
</style>
